// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"c55d29b2","302":"0371a4b6","445":"7745d3f5","974":"4145092e"}[chunkId] + ".chunk.js";
};